module.exports = __webpack_public_path__ + "img/visa-gold.99d26bf7.png";